import Vue from 'vue'
import Vuex from 'vuex'
import conversation from './modules/conversation'
import group from './modules/group'
import user from './modules/user'
import video from './modules/video'
import friend from './modules/friend'
import blacklist from './modules/blacklist'
import groupLive from './modules/groupLive'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        current: Date.now(), // 当前时间
        intervalID: 0,
        message: undefined
    },
    modules: {
        conversation,
        group,
        friend,
        blacklist,
        user,
        video,
        groupLive,
    },
    mutations: {
        //设置底部nav栏
        setFooterNav: function (state, type) {
            state.footerActive = type;
        },
        startComputeCurrent(state) {
            state.intervalID = setInterval(() => {
                state.current = Date.now()
            }, 500)
        },
        stopComputeCurrent(state) {
            clearInterval(state.intervalID)
            state.intervalID = 0
        },
        showMessage(state, options) {
            console.log("state:", state)
        },
    },
    getters: {
        hidden(state) {
            // eslint-disable-next-line no-unused-vars
            const temp = state.current
            if (typeof document.hasFocus !== 'function') {
                return document.hidden
            }
            return !document.hasFocus()
        }
    },
})

export default store